// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Landing_landingContainer__2gH_L"};